import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsWidget = ({ title, value, subtitle, icon, trend, trendValue, status = 'default' }) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'success':
        return 'border-success/20 bg-success/5';
      case 'warning':
        return 'border-warning/20 bg-warning/5';
      case 'error':
        return 'border-error/20 bg-error/5';
      default:
        return 'border-border bg-card';
    }
  };

  const getTrendStyles = () => {
    if (!trend) return '';
    return trend === 'up' ? 'text-success' : trend === 'down' ? 'text-error' : 'text-muted-foreground';
  };

  return (
    <div className={`p-6 rounded-xl border transition-micro hover-lift ${getStatusStyles()}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <p className="text-2xl font-semibold text-foreground mb-1">{value}</p>
          {subtitle && (
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          )}
          {trend && trendValue && (
            <div className={`flex items-center mt-2 text-sm ${getTrendStyles()}`}>
              <Icon 
                name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'} 
                size={16} 
                className="mr-1" 
              />
              <span>{trendValue}</span>
            </div>
          )}
        </div>
        <div className={`p-3 rounded-lg ${status === 'default' ? 'bg-primary/10' : 'bg-current/10'}`}>
          <Icon 
            name={icon} 
            size={24} 
            className={status === 'default' ? 'text-primary' : 'text-current'} 
          />
        </div>
      </div>
    </div>
  );
};

export default MetricsWidget;

